import { cva } from '@/styled-system/css';

export const switchHandleRecipe = cva({
  base: {
    'position': 'absolute',
    'transitionProperty': {
      _motionReduce: 'none',
      _motionSafe: 'color, transform',
    },
    'transitionDuration': {
      _motionReduce: '0s',
      _motionSafe: '{durations.400}',
    },
    'transitionTimingFunction': '{easings.ease}',
    '& .c11n_icon': {
      position: 'absolute',
      top: '0',
      left: '0',
      height: '100%',
      width: '100%',
    },
  },
  variants: {
    checkedState: {
      true: {
        color: 'Switch.Handle.selected',
      },
      false: {
        color: 'Switch.Handle.default',
      },
    },
    size: {
      md: {
        left: '100',
        top: '100',
        borderRadius: 'shape.ellipse',
        height: 'handle.xs',
        width: 'handle.xs',
      },
      lg: {
        left: '100',
        top: 'Switch.Handle.lg.position.top',
        borderRadius: 'shape.ellipse',
        height: 'handle.md',
        width: 'handle.md',
      },
    },
  },
  compoundVariants: [
    {
      size: 'md',
      checkedState: true,
      css: {
        transform: 'translateX({translate.Switch.Handle.md.x})',
      },
    },
    {
      size: 'lg',
      checkedState: true,
      css: {
        transform: 'translateX({translate.Switch.Handle.lg.x})',
      },
    },
  ],
});
